<template>
  <span :class="(color || 'primary') + '--text' + (bold ? ' font-weight-bold' : '')">
    <template v-if="v == ''">N/A</template>
    <template v-else>
      <span :class="priceClass" style="white-space: nowrap;">
        <template v-if="prefix">{{prefix}}</template>
        <currency :code="cur" :negative="v.startsWith('-')" />
        <span>{{left}}</span>
        <template v-if="right">
          <span>.</span>
          <div
            class="d-inline-block"
            style="font-size: .5em; line-height: .5em; vertical-align: middle; transform-origin: top left; transform: translateY(-.5em);"
            v-text="right"
          />
        </template>
      </span>
      <span
        v-if="per"
        :class="'ml-1 caption ' + (color || 'grey') + '--text' + (bold ? ' font-weight-bold' : '')"
        style="white-space: nowrap;"
        v-html="' per ' + per"
      />
    </template>
  </span>
</template>

<script>
import Currency from '@/components/Currency.vue';

const PRODUCT_PRICES = {
  CARD_PERSONAL: '6.00',
  CARD_GROUP: '8.00',
  CARD_INVITATION: '18.00',
  ADDTL_RECIPIENTS_BLOCK: '1.00',
  ADDTL_CONTRIBUTORS_BLOCK: '1.00'
};

export default {
  name: 'price',

  components: { Currency },

  props: {
    product: String,
    value: [ String, Number ],
    prefix: String,
    per: String,
    color: String,
    cur: { type: String, default: 'USD' },
    bold: Boolean,
    showDecimal: Boolean,
    priceClass: String
  },

  computed: {
    v() {
      return PRODUCT_PRICES[this.product] || (this.value == null ? '' : String(this.value));
    },

    left() {
      const left = this.v.split('.')[0].replace(/-/, '').replace(/^0+/, '');
      return parseInt(left || '0').toLocaleString('en-US');
    },

    right() {
      const v = this.v.split('.')[1];
      return this.showDecimal ? (v || '00') : (v == '00') ? null : v;
    }
  }
}
</script>
